import { jsx as _jsx } from "react/jsx-runtime";
import { Navbar as HeroNavbar, NavbarBrand as HeroNavbarBrand, NavbarContent as HeroNavbarContent, NavbarItem as HeroNavbarItem, NavbarMenuToggle as HeroNavbarMenuToggle, NavbarMenu as HeroNavbarMenu, NavbarMenuItem as HeroNavbarMenuItem } from '@heroui/react';
export const Navbar = ({ className, children, ...heroProps }) => {
    return (_jsx(HeroNavbar, { ...heroProps, ...(className && { className: `transition-standard ${className}` }), children: children }));
};
export const NavbarBrand = ({ className, children, ...heroProps }) => {
    return (_jsx(HeroNavbarBrand, { ...heroProps, ...(className && { className: `transition-standard ${className}` }), children: children }));
};
export const NavbarContent = ({ className, children, ...heroProps }) => {
    return (_jsx(HeroNavbarContent, { ...heroProps, ...(className && { className: `transition-standard ${className}` }), children: children }));
};
export const NavbarItem = ({ className, children, ...heroProps }) => {
    return (_jsx(HeroNavbarItem, { ...heroProps, ...(className && { className: `transition-standard ${className}` }), children: children }));
};
export const NavbarMenuToggle = ({ className, ...heroProps }) => {
    return (_jsx(HeroNavbarMenuToggle, { ...heroProps, ...(className && { className: `transition-standard ${className}` }) }));
};
export const NavbarMenu = ({ className, children, ...heroProps }) => {
    return (_jsx(HeroNavbarMenu, { ...heroProps, ...(className && { className: `transition-standard ${className}` }), children: children }));
};
export const NavbarMenuItem = ({ className, children, ...heroProps }) => {
    return (_jsx(HeroNavbarMenuItem, { ...heroProps, ...(className && { className: `transition-standard ${className}` }), children: children }));
};
//# sourceMappingURL=Navbar.js.map